import { z } from 'zod';

export const operatorSchema = z.object({
  operator: z.object({
    first_name: z.string({ message: 'Name is required' }),
    email: z.string().email({ message: 'Please enter a valid email address' }).optional(),
    phone_number: z.string({ message: 'Phone number is required' }).min(1, { message: 'Phone number is required' })
  })
});
